import FilterButtonAtom from '../../atoms/buttons/filterButton';
import useList from '../../../../shared/components/utils/hooks/useList';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';
import { useAppSelector } from '../../../../shared/store/hooks';
import { useEffect, useMemo } from 'react';

interface Props {
  active: boolean;
  index: number;
  text: string;
  onFocus?: () => void;
}

function FilterButton({ active, index, text, onFocus }: Props) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const { listIndex, focused: listFocused } = useList(index);
  const focused = useMemo(
    () => !enabled && listFocused && listIndex === index,
    [enabled, listFocused, listIndex]
  );

  useEffect(() => {
    if (focused) {
      onFocus && onFocus();
    }
  }, [focused]);

  return listIndex <= index ? (
    <FilterButtonAtom
      fill={active ? 1 : 0}
      focused={!enabled && focused && listIndex === index}
      onMouseEnter={onFocus}
    >
      {text}
    </FilterButtonAtom>
  ) : null;
}

export default FilterButton;
